export default "__VITE_ASSET__CokBZWGk__"